import gql from 'graphql-tag';

const query = gql`
  query TrackerHistory($startDate: Date!, $endDate: Date!) {
    dailyTracker {
      history(startDate: $startDate, endDate: $endDate) {
        id
        date
        baseCalories
        trainingCalories
        totalCalories
        consumedCalories
        remainingCalories
        isGoalAchieved
      }
    }
  }
`;

export default query;
